// extracted by mini-css-extract-plugin
module.exports = {"borderGrey":"#B5B4B5","zIndexModalBackdrop":"1040","container":"_1djt-7Rs_cYgS6iv","mainMessage":"_2AWrZ-ZHpSmGjluw","subMessage":"_3w6OoOqoUWA1chrt"};